package com.essntl.features.invoice.ui.addeditinvoice

import core.validation.Form
import core.validation.field.Field
import core.validation.field.StringField
import core.validation.validator.NonEmptyValidator

class AddEditInvoiceValidation {
    val addEditInvoiceForm = AddEditInvoiceForm()
}

class AddEditInvoiceForm : Form() {
    val dueDate = StringField(
        NonEmptyValidator,
    )
    override val fields: List<Field> = listOf(
        dueDate,
    )
}